import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const PageIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 214 102">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h214v102H0z" />
      <path
        d="M21.39 59v-9.184h1.163v8.19h4.018V59h-5.18zm9.33.168c-.42 0-.822-.08-1.205-.238a3.014 3.014 0 01-.994-.686 3.568 3.568 0 01-.7-1.12 4.281 4.281 0 01-.252-1.512c0-.57.084-1.073.252-1.512.178-.448.411-.826.7-1.134.29-.308.621-.541.994-.7a3.112 3.112 0 011.204-.238 3.01 3.01 0 012.198.938c.29.308.518.686.686 1.134.178.439.266.943.266 1.512a4.08 4.08 0 01-.266 1.512 3.378 3.378 0 01-.686 1.12c-.289.299-.625.527-1.008.686a3.01 3.01 0 01-1.19.238zm0-.952c.289 0 .555-.06.797-.182.243-.13.448-.308.616-.532a2.53 2.53 0 00.406-.826c.094-.317.14-.672.14-1.064s-.046-.747-.14-1.064a2.514 2.514 0 00-.406-.84 1.678 1.678 0 00-.616-.532 1.656 1.656 0 00-.798-.196c-.289 0-.555.065-.798.196a1.797 1.797 0 00-.63.532 2.687 2.687 0 00-.392.84c-.093.317-.14.672-.14 1.064s.047.747.14 1.064c.094.317.224.593.392.826.178.224.388.401.63.532.243.121.51.182.798.182zM35.81 59v-6.804h.952l.098 1.232h.042c.234-.43.514-.77.84-1.022.336-.252.7-.378 1.092-.378.27 0 .514.047.728.14l-.224 1.008a1.825 1.825 0 00-.658-.112c-.29 0-.592.117-.91.35-.308.233-.578.64-.812 1.218V59h-1.148zm7.625.168a3.47 3.47 0 01-1.288-.238 3.275 3.275 0 01-1.036-.7 3.377 3.377 0 01-.686-1.12 4.166 4.166 0 01-.252-1.498c0-.56.084-1.06.252-1.498.177-.448.406-.826.686-1.134.29-.308.616-.541.98-.7a2.677 2.677 0 011.134-.252 2.8 2.8 0 011.148.224c.345.15.63.364.854.644.233.28.41.616.532 1.008.121.392.182.83.182 1.316 0 .121-.005.243-.014.364 0 .112-.01.21-.028.294h-4.592c.047.728.27 1.307.672 1.736.41.42.943.63 1.596.63.327 0 .625-.047.896-.14a4.22 4.22 0 00.798-.392l.406.756c-.299.187-.63.35-.994.49s-.78.21-1.246.21zm-2.142-4.116h3.64c0-.69-.15-1.213-.448-1.568-.29-.364-.7-.546-1.232-.546-.243 0-.476.047-.7.14-.215.093-.41.233-.588.42a2.27 2.27 0 00-.448.658 3.15 3.15 0 00-.224.896zM47.774 59v-6.804h.951l.098.98h.042c.3-.327.621-.597.966-.812a2.11 2.11 0 011.148-.336c.523 0 .93.117 1.218.35.3.224.518.541.658.952.355-.392.71-.705 1.064-.938a2.08 2.08 0 011.176-.364c.7 0 1.218.224 1.554.672.346.448.518 1.11.518 1.988V59H56.02v-4.158c0-.644-.102-1.106-.308-1.386-.205-.29-.522-.434-.952-.434-.513 0-1.082.35-1.708 1.05V59h-1.148v-4.158c0-.644-.102-1.106-.308-1.386-.205-.29-.527-.434-.966-.434-.513 0-1.082.35-1.708 1.05V59h-1.148zm12.359-4.886a.846.846 0 01-.602-.238.882.882 0 01-.238-.63c0-.27.08-.485.238-.644a.822.822 0 01.602-.252c.224 0 .415.084.574.252.168.159.252.373.252.644a.855.855 0 01-.252.63.782.782 0 01-.574.238zm0 5.054a.846.846 0 01-.602-.238.882.882 0 01-.238-.63c0-.27.08-.485.238-.644a.822.822 0 01.602-.252c.224 0 .415.084.574.252.168.159.252.373.252.644a.855.855 0 01-.252.63.782.782 0 01-.574.238z"
        fill="#666"
      />
      <rect
        opacity={0.4}
        x={79}
        y={38}
        width={80}
        height={32}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={104}
        y={48}
        width={45}
        height={4}
        rx={2}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={104}
        y={57}
        width={29}
        height={4}
        rx={2}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <circle opacity={0.4} cx={93} cy={54} r={8} fill="#2962FF" fillOpacity={0.3} />
      <rect
        opacity={0.4}
        x={79}
        y={20}
        width={114}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={79}
        y={80}
        width={89}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={20}
        y={20}
        width={36}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={20}
        y={80}
        width={29}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={174}
        y={80}
        width={8}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
    </svg>
  </SvgIcon>
);

export default PageIcon;
